export class ListGitRepositoriesFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "integrationId",
            "baseName": "integrationId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "provider",
            "baseName": "provider",
            "type": "GitProviderFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "GitRepositoryStatusFilters",
            "format": ""
        },
        {
            "name": "fullName",
            "baseName": "fullName",
            "type": "StringFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGitRepositoriesFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
